module.exports = __webpack_public_path__ + "static/media/flag04.5052089c.svg";